import { createFileRoute, redirect } from '@tanstack/react-router';

/** Retired tab — costing now lives in the single Recurring jobs page (moment 6). */
export const Route = createFileRoute('/_dashboard/dashboard/settings/contracts/costing')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard/settings/contracts' });
  },
  component: () => null,
});
